angular.module('meevo.plugins.waitList').filter('meevo.plugins.waitList.filters.appointmentRequestService', [
    () => (appointmentRequestServices: Meevo.Model.AppointmentRequestService[], clientId: string) => {
        if (!appointmentRequestServices) {
            return [];
        }

        return appointmentRequestServices.filter((appointmentRequestService) =>
            appointmentRequestService.clientId === clientId);
    }
]);